import placeholderImage from '../../assets/images/placeholder-image.png';

export default function Optimizee(url, maxWidth) {
    if (!url) {
        return placeholderImage;
    }

    if (maxWidth) {
        return `https://www.optimizee.xyz/images/${btoa(url)},${maxWidth}.jpg`;
    }

    return `https://www.optimizee.xyz/images/${btoa(url)}.jpg`;
}
